import CommerceService from "../../CommerceService"

const CommerceStore = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/stores'
        if (r != undefined) {
            url = '/stores?' + r
        }
        return CommerceService.get(url)
    },
    getProducts(id) {
        const url = `/stores/${id}/products`;
        return CommerceService.get(url)
    }
}
export default CommerceStore
